import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rightPane", "paymentDisplay", "progressIndicator"]

  connect() {
    this.initializeRealTimeUpdates()
    this.initializeProgressAnimations()
  }

  initializeRealTimeUpdates() {
    // Event listeners available for future real-time calculation updates
  }

  initializeProgressAnimations() {
    // Animate progress bars with easing
    const progressBars = document.querySelectorAll('.progress-bar')
    progressBars.forEach(bar => {
      const targetWidth = bar.style.width
      bar.style.width = '0%'
      
      setTimeout(() => {
        bar.style.transition = 'width 1s ease-out'
        bar.style.width = targetWidth
      }, 300)
    })
  }

  animateValueChange(element) {
    // Add visual feedback when values change
    element.classList.add('animate-pulse')
    element.style.color = '#10b981' // green-500
    
    setTimeout(() => {
      element.classList.remove('animate-pulse')
      element.style.color = ''
    }, 800)
  }

  formatCurrency(amount) {
    if (!amount || isNaN(amount)) return '$0'
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount)
  }

  // Micro-interaction for trust building
  showSecurityIndicator() {
    const indicator = document.createElement('div')
    indicator.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium z-50 transform translate-x-full'
    indicator.innerHTML = `
      <div class="flex items-center space-x-2">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        <span>Data Secured</span>
      </div>
    `
    
    document.body.appendChild(indicator)
    
    // Animate in
    setTimeout(() => {
      indicator.style.transform = 'translateX(0)'
      indicator.style.transition = 'transform 0.3s ease-out'
    }, 100)
    
    // Animate out
    setTimeout(() => {
      indicator.style.transform = 'translateX(full)'
      setTimeout(() => indicator.remove(), 300)
    }, 2000)
  }

  // Progressive disclosure animations
  revealNextSection(section) {
    section.style.opacity = '0'
    section.style.transform = 'translateY(20px)'
    section.style.display = 'block'
    
    setTimeout(() => {
      section.style.transition = 'all 0.5s ease-out'
      section.style.opacity = '1'
      section.style.transform = 'translateY(0)'
    }, 100)
  }

  // Conversion psychology triggers
  triggerSocialProof() {
    const messages = [
      "142 businesses funded this week",
      "95% approval rate for similar businesses",
      "Average approval: $47,000 for your industry"
    ]
    
    const randomMessage = messages[Math.floor(Math.random() * messages.length)]
    this.showTemporaryMessage(randomMessage, 'bg-blue-500')
  }

  showTemporaryMessage(message, bgColor = 'bg-green-500') {
    const messageEl = document.createElement('div')
    messageEl.className = `fixed bottom-4 right-4 ${bgColor} text-white px-4 py-3 rounded-lg shadow-lg text-sm font-medium z-50 max-w-xs transform translate-y-full`
    messageEl.textContent = message
    
    document.body.appendChild(messageEl)
    
    setTimeout(() => {
      messageEl.style.transform = 'translateY(0)'
      messageEl.style.transition = 'transform 0.3s ease-out'
    }, 100)
    
    setTimeout(() => {
      messageEl.style.transform = 'translateY(full)'
      setTimeout(() => messageEl.remove(), 300)
    }, 4000)
  }
}